import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { BsChevronLeft } from 'react-icons/bs';
import { CONTROL_ELECTION } from 'src/constants';
import { convertDatasets } from 'src/utils/datasets';
import { GET } from 'src/utils/services';
import styled from 'styled-components';

const WidgetRollBack = ({ text = '' }) => {
  if (CONTROL_ELECTION === 'false') return null;
  const [resData, setResData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const resDataSet = await GET('/api/datasets');
      if (!_.isEmpty(resDataSet)) {
        const resData = convertDatasets(resDataSet, 'section-ele66', false);
        setResData({ item1: convertDatasets(resData?.[0], 'lock-cate', true) }, { item2: convertDatasets(resData?.[0], 'nav-text', true) });
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {!_.isEmpty(resData?.item1) && (
        <WidgetWrapper className='container'>
          <a href={resData?.item1}>
            <div className='rb-wrapper'>
              <div className='rb-svg'>
                <BsChevronLeft />
              </div>
              <div className='rb-text'>{resData?.item2 || text}</div>
            </div>
          </a>
        </WidgetWrapper>
      )}
    </>
  );
};

export default WidgetRollBack;

const WidgetWrapper = styled.div`
  .rb-wrapper {
    display: flex;
    align-items: center;
    margin: 15px 0;
    .rb-svg {
      background: #000;

      padding: 3px 5px 3px 5px;
      svg {
        color: var(--primary-color);
        vertical-align: middle;
        font-size: 18px;
        font-weight: 700;
      }
    }
    .rb-text {
      background: var(--primary-color);

      font-weight: 500;
      padding: 4px 5px 2px 5px;
    }
  }
`;
